import { useFetchLoanOfficerQuery } from "../../../../../redux/queries"
import { PendingSubscriptionFull } from "../../../../../types"
import {
  DEFAULT_DATETIME_LONG_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"

type Props = {
  info: PendingSubscriptionFull
  onClick: (row: PendingSubscriptionFull) => void
}

const OwnerCell = ({ info, onClick }: Props) => {
  const { created, loid } = info

  // get lo by loid
  const { data: lo } = useFetchLoanOfficerQuery(loid)

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer hidden md:table-cell"
      onClick={() => onClick(info)}
    >
      <div className="text-sm text-black">
        {formatDateTimeFromTimestamp(created, DEFAULT_DATETIME_LONG_FORMAT)}
      </div>
      <div className="text-sm text-black">by {lo?.email || "N/A"}</div>
    </td>
  )
}

export default OwnerCell
